import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-char-counter',
  templateUrl: './char-counter.component.html',
  styleUrls: ['./char-counter.component.scss'],
})
export class CharCounterComponent {
  @Input() currentLength: number = 0;
  @Input() maxLength: number = 100;
}
